import {useEffect} from "react";
import {Button, Field, Icon, Text, VStack} from "@chakra-ui/react";
import ControlledInput from "@/components/ui/foundation/ControlledInput";
import {HiOutlinePlus} from "react-icons/hi2";
import useEditableList from "@/components/hooks/useEditableList";

const DataFieldsPanel = ({values, label, description, buttonLabel, fieldPlaceholder, onChange}) => {
    const {items, addItem, removeItem, editItem, changeItem} = useEditableList([...values]);

    useEffect(() => {
        onChange(items);
    }, [values, items]);

    return (
        <VStack w={'full'} alignItems={'flex-start'}>
            <Field.Root>
                <Field.Label color={'white'} fontSize={18}>
                    {label}
                </Field.Label>
                <Field.HelperText>{description}</Field.HelperText>
            </Field.Root>
            {items?.map((item) => (
                <ControlledInput key={item.id}
                                 fieldId={item.id}
                                 isDisabled={item.disabled}
                                 canRemove={items.length > 1}
                                 value={item.value}
                                 placeholder={fieldPlaceholder}
                                 onTrashClick={() => removeItem(item.id)}
                                 onChangeText={(value) => changeItem(item.id, value)}
                                 onEditClick={editItem}/>
            ))}
            <Button variant="outlined" textDecoration='unset' onClick={addItem} alignSelf={'end'}>
                <Icon fontSize={46}>
                    <HiOutlinePlus/>
                </Icon>
                <Text>{buttonLabel}</Text>
            </Button>
        </VStack>
    )
}

export default DataFieldsPanel;
